import React from "react";

export default function UploadCloud({ color = "currentColor", width = 32, height = 32, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="12"
        fill="transparent"
      />

      {/* Use currentColor here */}
      <path
        d="M12 7C10.2227 7 8.71492 8.10115 8.1041 9.63339C6.91036 9.95811 6 11.0554 6 12.3446C6 13.8189 7.1499 15.0284 8.64317 15.1577L8.664 15.1595H10.5266C10.7889 15.1595 11.0015 14.9509 11.0015 14.6936C11.0015 14.4363 10.7889 14.2277 10.5266 14.2277H8.70692C7.70525 14.1314 6.94969 13.3214 6.94969 12.3446C6.94969 11.4206 7.66114 10.6353 8.54197 10.4913L8.82869 10.4444L8.91654 10.1725C9.33619 8.87402 10.5603 7.93176 12 7.93176C13.6695 7.93176 15.0509 9.19406 15.2109 10.7647L15.2493 11.1413L15.6328 11.1816C16.4343 11.2658 17.0503 11.9071 17.0503 12.706C17.0503 13.497 16.4464 14.1335 15.6565 14.2277H13.4734C13.2111 14.2277 12.9985 14.4363 12.9985 14.6936C12.9985 14.9509 13.2111 15.1595 13.4734 15.1595H15.7088L15.734 15.1568C16.9953 15.0243 18 14.0032 18 12.706C18 11.5385 17.1862 10.5947 16.104 10.321C15.7392 8.44536 14.0359 7 12 7Z"
        fill="currentColor"
      />

      <path
        d="M11.6642 10.6225C11.7101 10.5775 11.7631 10.5436 11.8196 10.5209C11.8752 10.4984 11.9361 10.4861 12 10.4861C12.1264 10.4861 12.2412 10.5345 12.3263 10.6134C12.3298 10.6168 12.3334 10.6201 12.3368 10.6235L14.1775 12.4294C14.3629 12.6114 14.3629 12.9064 14.1775 13.0883C13.992 13.2702 13.6914 13.2702 13.5059 13.0883L12.4748 12.0767V16.7341C12.4748 16.9914 12.2622 17.2 12 17.2C11.7377 17.2 11.5252 16.9914 11.5252 16.7341V12.0767L10.494 13.0883C10.3086 13.2702 10.0079 13.2702 9.82251 13.0883C9.63707 12.9064 9.63707 12.6114 9.82251 12.4294L11.6642 10.6225Z"
        fill="currentColor"
      />
    </svg>
  );
}
